module.exports = __webpack_public_path__ + "media/images/restaurant/savor_logo_zh_hans-9f537af0067abc6346f7d41e93fc0c32.png";